let prefix = '/api/sap/traceability';

function getReportTraceabilitySAP(data) {
    return window.axios.post(prefix + '/report', {
        startDate: data.dateInitial,
        endDate: data.dateFinal,
        Whs: data.warehouse
    })
}


function exportDocumentSAP(data) {
    return window.axios.post(prefix + '/export/document', 
        data,
        { responseType: 'blob' }
    );

}

export default {
    getReportTraceabilitySAP,
    exportDocumentSAP,
}
